import { environment } from '../../environments/environment';

export function apiUrl(path = ''): string {
  const base = environment.apiUrl.replace(/\/$/, '');
  const clean = path.replace(/^\//, '');
  return clean ? `${base}/${clean}` : base;
}

export function isApiRequest(url: string): boolean {
  return url.startsWith(environment.apiUrl) || url.startsWith('/api/');
}
